import "./App.css";
import RoutesComponent from "./components/RoutesComponent";

function App() {
  return (
    <div className="App">
      <RoutesComponent />
    </div>
  );
}

export default App;
